<template>
  <div id="loginForm">
    <div
      v-if="env === 'local' || env === 'dev'"
      class="shortcutsWrapper"
    >
      <div class="shortcuts">
        <div class="title">
          shortcuts
        </div>

        <!-- Sessions -->
        <el-button
          v-for="(item, key) in short.session"
          :key="`Se${key}`"
          @click="shortcut(`${item}@sccoaching.com`)"
        >
          Session {{ key }}
        </el-button>

        <hr style="width: 100%; margin-bottom: 16px;" />

        <!-- Coaches -->
        <el-button
          v-for="(item, key) in short.coach"
          :key="`Co${key}`"
          @click="shortcut(`${item}@sccoaching.com`)"
        >
          Coach({{ item }})
        </el-button>

        <hr style="width: 100%; margin-bottom: 16px;" />

        <!-- Admins -->
        <el-button
          v-for="(item, key) in short.oa"
          :key="`oa${key}`"
          @click="shortcut(`${item}@sccoaching.com`)"
        >
          OA ({{ item }})
        </el-button>

        <el-button
          v-for="(item, key) in short.mam"
          :key="`ma${key}`"
          @click="shortcut(`${item}@sccoaching.com`)"
        >
          MAM ({{ item }})
        </el-button>

        <hr style="width: 100%; margin-bottom: 16px;" />

        <!-- Onboard Leaders -->
        <el-button
          v-for="(item, key) in short.leader_on"
          :key="`Le${key}`"
          @click="shortcut(`${item}@sccoaching.com`)"
        >
          Leader (On_B {{ item }})
        </el-button>
      </div>
    </div>

    <el-card
      shadow="hover"
      class="box-card login-form-card"
      :body-style="{padding: '0px'}"
    >
      <div
        slot="header"
        class="clearfix"
      >
        <div class="title defaultCursor">
          {{ $t('account.login.title') }}
        </div>
      </div>

      <div class="content">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="rules"
          @keyup.enter="login"
        >
          <el-form-item
            prop="email"
            :label="$t('account.emailAddress')"
          >
            <el-input
              v-model="loginForm.email"
              :placeholder="$t('common.email')"
              @keydown.native.enter.prevent="login"
            />
          </el-form-item>

          <el-form-item
            prop="password"
            :label="$t('common.password')"
          >
            <el-input
              v-model="loginForm.password"
              :placeholder="$t('common.password')"
              show-password
              @keydown.native.enter.prevent="login"
            />
          </el-form-item>
        </el-form>
        <div class="forgetPasswordLink">
          <!-- <a href="/account/password_reset">I forgot my password</!-->
          <router-link :to="{name: 'resetPassword'}">
            {{ $t('account.login.askForgot') }}
          </router-link>
        </div>

        <div class="actions">
          <el-button
            style="width: 100%; background: #1a97f2;"
            type="primary"
            block
            :loading="loading"
            @click="login"
          >
            {{ $t('common.login') }}
          </el-button>
        </div>
      </div>

      <div class="cardFooter">
        {{ $t('account.login.askCoach') }}
        <a :href="coachLoginLink">{{ $t('account.login.loginCoach') }}</a>
      </div>
    </el-card>

    <div class="supportLink">
      {{ $t('common.forSupport') }}
      <a href="mailto:support@globalcoachgroup.com">Support@GlobalCoachGroup.com</a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import api from '@/api';
import qs from 'qs';

export default {
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      rules: {
        email: [{
          required: true,
          message: `${this.$t('common.rule.login.enterEmail')}`,
          trigger: ['blur', 'change'],
        },
        {
          type: 'email',
          message: `${this.$t('common.rule.login.emailEx')}`,
          trigger: ['blur'],
        }],
        password: [{
          required: true,
          message: `${this.$t('common.rule.login.enterPw')}`,
          trigger: ['blur', 'change'],
        }],
      },
      loading: false,

      // // ////
      // // For Testing shortcut
      // // ////
      short: {
        session: [
          'demo0', 'demo1', 'demo2', 'demo3', 'demo4',
          'demo5', 'demo6', 'demo7', 'demo8', 'demo9',
        ],
        oa: ['demo10', 'demo20'],
        mam: ['support1'],
        coach: [
          'demo11', 'jisu.coach', 'yry.coach', 'support', 'demo19', 'demo20', 'dcc1', 'dcc2',
          'dcc3', 'dcc4', 'dcc5', 'sjy17', 'sjy18', 'sjy19', 'sjy20',
        ],
        leader_on: [
          'dcc6', 'dcc7', 'dcc8', 'dcc9', 'dcc10', 'dcc11', 'dcc12',
          'dcc13', 'dcc14', 'dcc15', 'dcc16', 'dcc17', 'dcc18', 'dcc19', 'dcc20',
          'sjy1', 'sjy2', 'sjy3', 'sjy4', 'sjy5', 'sjy6', 'sjy7', 'sjy8', 'sjy8', 'sjy10',
          'sjy11', 'sjy12', 'sjy13', 'sjy14', 'sjy15', 'sjy16',
        ],
      },
    };
  },

  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    },

    coachLoginLink() {
      const params = {};
      if (this.$route.query.redirect_to) {
        params.redirect_to = this.$route.query.redirect_to;
      }
      return `${process.env.VUE_APP_CAS_CLIENT}/login${qs.stringify(params, { addQueryPrefix: true })}`;
    },
  },

  methods: {
    ...mapMutations('user', [
      'loginUser',
    ]),

    async login() {
      try {
        this.loading = true;
        this.$Progress.start();
        await this.$refs.loginForm.validate();

        const response = await api.INGLogin(this.loginForm);
        console.log(response);
        await this.loginUser({ user: response.data });

        if (this.$route.query.destination) {
          this.$router.push(this.$route.query.destination).catch((err) => {});
        } else if (this.$route.query.redirect_to) {
          window.location.href = this.$route.query.redirect_to;
        } else {
          this.$router.push({ name: 'dashboard' }).catch((err) => {});
        }
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
        this.$Progress.finish();
      }
    },

    shortcut(email, password) {
      const pw = password || '12345678';
      this.loginForm.email = email;
      this.loginForm.password = pw;
      this.login();
    },
  },
};
</script>

<style lang="scss">
#loginForm {
  transition: all 200ms ease;

  .login-form-card {
    width: 440px;
    max-width: 90%;
    margin: 0 auto;
    border-radius: 4px;
    border-width: 0;

    .el-card__header {
      background-color: rgb(0, 56, 101);

      .title {
        font-size: 1.25rem;
        color: white;
      }
    }

    .content {
      padding: 20px;

      .el-form {
        .el-input__inner {
          border-radius: 0;
          border-top: 0;
          border-left: 0;
          border-right: 0;
          padding: 0;
          font-size: 16px;
        }
      }

      .forgetPasswordLink {
        float: right;
        margin-bottom: 10px;
        font-size: 14px;
      }

      .actions {
        text-align: center;

        .el-button {
          margin: 10px 0 20px;
          width: 145px;
        }
      }
    }

    .cardFooter {
      white-space: break-spaces;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #cbcbcb;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 17px;
      letter-spacing: 0;
      text-align: center;
    }
  }

  .supportLink {
    margin-top: 20px;
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0;
    text-align: center;

    a {
      color: white;
    }
  }

  // FOR DEV
  .shortcutsWrapper {
    position: absolute;
    width: 100%;
    height: 160px;
    top: 20px;

    .shortcuts {
      display: flex;
      flex-wrap: wrap;
      height: 105px;
      width: 600px;
      max-width: 90%;
      margin: 0 auto;
      background-color: #b1afafa3;
      padding: 10px;
      margin-bottom: 15px;
      border-radius: 10px;
      overflow: auto;
      justify-content: center;
      align-items: center;

      div.title {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
        font-weight: bold;
        text-decoration: underline;
      }

      button {
        padding: 8px;
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    // /FOR DEV
  }
}
</style>
